import metadata from 'libphonenumber-js/metadata.min.json'

const displayNames = typeof Intl !== 'undefined' && typeof Intl.DisplayNames !== 'undefined'
  ? new Intl.DisplayNames(['en'], { type: 'region' })
  : null

const isoToFlag = iso2 => {
  if (!iso2) return '🏳️'
  return iso2
    .toUpperCase()
    .replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt(0)))
}

const getCountryName = iso2 => {
  if (!iso2) return 'Unknown'
  if (displayNames) {
    try {
      const label = displayNames.of(iso2)
      if (label) return label
    } catch (error) {
      // ignore lookup errors
    }
  }
  return iso2
}

const dialCodeOptionsMap = {}

Object.entries(metadata.country_calling_codes || {}).forEach(([code, isoList]) => {
  isoList.forEach(iso2 => {
    const normalizedIso = (iso2 || '').toUpperCase()
    if (!normalizedIso || dialCodeOptionsMap[normalizedIso]) return
    dialCodeOptionsMap[normalizedIso] = {
      iso2: normalizedIso,
      name: getCountryName(normalizedIso),
      dial_code: `+${code}`,
      flag: isoToFlag(normalizedIso),
    }
  })
})

const dialCodeOptions = Object.values(dialCodeOptionsMap).sort((a, b) => a.name.localeCompare(b.name))

export default dialCodeOptions
